import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function ChandlerJoin() {
  const dateTexts = ['18xx年'];
  const title = 'チャンドラーがS.E.A.に加入';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/discovery-bay-hyperion.jpg'
  const description = (
    <>
      <a href='/jason-chandler'>
        {'ジェイソン・チャンドラー'}
      </a>
      {'がS.E.A.に加入する。この時期のS.E.A.の活動に大きく貢献したメンバーの一人だと思われる。'}
    </>
  );
  const quoteDomain = 'Disney';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default ChandlerJoin;
